import { render, staticRenderFns } from "./ProblemaCoracao.vue?vue&type=template&id=75e83caa&scoped=true"
import script from "./ProblemaCoracao.vue?vue&type=script&lang=js"
export * from "./ProblemaCoracao.vue?vue&type=script&lang=js"
import style0 from "./ProblemaCoracao.vue?vue&type=style&index=0&id=75e83caa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75e83caa",
  null
  
)

export default component.exports